import React from "react";
import { Link } from "@reach/router";

import {
  CONTACT_US,
  PRIVACY_POLICY,
  TERMS_OF_USE,
  ALL_RIGHTS_RESERVED,
  SUPPORT_EMAIL_ID,
} from "constants/common";

import "./footer.scss";

export default function Footer() {
  const CONTACT_MAIL = `mailto:${SUPPORT_EMAIL_ID}`;
  const LOGO_URL = "/logo_zoomed_90x90.png";

  return (
    <div id="container-footer">
      {/* Separator */}
      <div id="separator-footer"></div>
      {/* Logo */}
      <div id="container-logo-footer">
        <img
          id="img-logo-footer"
          src={LOGO_URL}
          alt="Edify Logo"
          width="50px"
          height="50px"
        />
        <p id="text-footer-edify" className="text-footer">
          Edify
        </p>
      </div>
      {/* Products */}
      <div className="container-footer-links-products">
        <p className="text-footer-heading text-footer">Products</p>
        <Link to="/teach" className="link-footer">
          <p className="text-footer-link text-footer">For trainers</p>
        </Link>
        <Link to="/learn" className="link-footer">
          <p className="text-footer-link text-footer">For learners</p>
        </Link>
        <Link to="/teach" className="link-footer">
          <p className="text-footer-link text-footer">Become a trainer</p>
        </Link>
        <p className="text-footer-link text-footer">Download Edify</p>
      </div>
      {/* Support */}
      <div className="container-footer-links-support">
        <p className="text-footer-heading text-footer">Support</p>
        <a href={CONTACT_MAIL} className="link-footer">
          <p className="text-footer-link text-footer">Help Center</p>
        </a>
        <a href={CONTACT_MAIL} className="link-footer">
          <p className="text-footer-link text-footer">{CONTACT_US}</p>
        </a>
        <Link to="/privacy" className="link-footer">
          <p className="text-footer-link text-footer">{PRIVACY_POLICY}</p>
        </Link>
        <Link to="/terms" className="link-footer">
          <p className="text-footer-link text-footer">{TERMS_OF_USE}</p>
        </Link>
      </div>
      {/* Creators' App Links */}
      <div className="container-app-links-fc">
        <p className="text-footer-heading text-footer-heading-fc text-footer">
          Creators App
        </p>
        <img
          className="button-android-trainer-footer button-android-footer"
          src="/play-store.jpeg"
          width="200px"
        />
        <img
          className="button-ios-trainer-footer button-ios-footer"
          src="/apple-image.svg"
          width="200px"
        />
      </div>
      {/* Learners' App Links */}
      <div className="container-app-links-fl">
        <p className="text-footer-heading text-footer-heading-fl text-footer">
          Learners App
        </p>
        <img
          className="button-android-learner-footer button-android-footer"
          src="/play-store.jpeg"
          width="200px"
        />
        <img
          className="button-ios-learner-footer button-ios-footer"
          src="/apple-image.svg"
          width="200px"
        />
      </div>
      {/* Copyright */}
      <p id="text-footer-copyright" className="text-footer">
        {ALL_RIGHTS_RESERVED}
      </p>
    </div>
  );
}
